<template>
  <div>
    <div
      v-if="isPc"
      class="cart-fixed"
      @click="$router.push('/cart?userIntegral=' + userIntegral)"
    >
      <i v-if="cartTotal > 0">{{ cartTotal }}</i>
    </div>
    <div v-else class="cart-fixed" @touchstart.prevent="move">
      <i v-if="cartTotal > 0">{{ cartTotal }}</i>
    </div>
  </div>
</template>
<script>
export default {
  name: "cart",
  props: {
    cartTotal: {
      type: Number,
      default: null,
    },
    userIntegral: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isPc: true,
      intervalId: null,
    };
  },
  mounted() {
    if (
      navigator.userAgent.match(
        /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i
      )
    ) {
      //跳转移动端页面
      this.isPc = false;
    } else {
      //跳转pc端页面
      this.isPc = true;
    }
  },
  methods: {
    // 悬浮按钮的拖拽事件,合并单击事件行为
    move(e) {
      let startTime = new Date().getTime(); //获取当前按下时的时间
      let odiv = e.target; //获取目标元素
      const maxLeft = window.outerWidth - 40; //left最大值,40是目标元素的宽
      const maxTop = window.outerHeight - 40; //top最大值，40是目标元素的高
      let t = e.targetTouches[0];
      let x = t.clientX - t.target.offsetLeft; //触碰点当前距离事件源的左距
      let y = t.clientY - t.target.offsetTop; //触碰点当前距离事件源的上距
      document.ontouchmove = (e) => {
        //鼠标按下并移动的事件
        //用鼠标的位置减去鼠标相对元素的位置(默认20)，得到元素的位置
        const touch = e.changedTouches[0];
        let left = touch.clientX - x;
        let top = touch.clientY - y;
        // 设置移动范围
        if (left <= 0) left = 0;
        if (left >= maxLeft) left = maxLeft;
        if (top <= 46) top = 46; //最小为头部底边
        if (top >= maxTop) top = maxTop;
        //移动当前元素(改变定位)
        odiv.style.left = left + "px";
        odiv.style.top = top + "px";
      };
      document.ontouchend = () => {
        // debugger
        document.ontouchmove = null;
        e.preventDefault();
        var nowTime = new Date().getTime(); //松开时的时间
        // 小于300ms可以识别为点击事件的范围,最好设置为50
        if (nowTime - startTime <= 500)
          this.$router.push("/cart?userIntegral=" + this.userIntegral);
      };
    },
  },
};
</script>


<style lang="less" scoped>
.cart-fixed {
  position: fixed;
  right: 14px;
  bottom: 92px;
  width: 62px;
  height: 62px;
  background: url("../../image/yky/购物车@2x.png") no-repeat;
  background-size: contain;
  i {
    display: block;
    position: absolute;
    top: 5px;
    right: 5px;
    background: #ff4446;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    line-height: 15px;
  }
}
</style>